<template>
    <b-modal id="save-confirm-leave" centered :title="'Сохранить изменения?'">
        <template #default>
            <slot name="contents">
            </slot>
        </template>
        <template #modal-footer>
            <b-button variant="secondary" @click="stay()">Не сохранять</b-button>
            <b-button variant="primary" @click="continueAndSave()">Сохранить и продолжить</b-button>
        </template>
    </b-modal>
</template>

<script>
export default {
    name: "ConfirmSaveModal",
    data() {
        return {
            resolveLeave: null,
            rejectLeave: null,
        }
    },
    methods: {
        showConfirmSave() {
            this.$bvModal.show('save-confirm-leave');
            return new Promise((resolve, reject) => {
                this.resolveLeave = resolve;
                this.rejectLeave = reject;
            })
        },
        stay() {
            this.$bvModal.hide('save-confirm-leave');
            this.rejectLeave();
        },
        continueAndSave() {
            this.$bvModal.hide('save-confirm-leave');
            this.resolveLeave();
        }
    }
}
</script>

<style scoped>

</style>